import Reveal from '@/components/feature/Reveal';
import { useTranslation } from 'react-i18next';

interface LocationMapProps {
  variant?: 'light' | 'default';
}

export default function LocationMap({ variant = 'default' }: LocationMapProps) {
  const { t } = useTranslation();

  const bg = variant === 'light' ? 'bg-background-100' : 'bg-background-50';

  return (
    <section className={`w-full py-16 md:py-20 ${bg}`}>
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold mb-4">
              <i className="ri-map-pin-line"></i>
              {t('contactPage.badge')}
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              {t('contactPage.mapTitle')}
            </h2>
          </Reveal>
          <Reveal delay={100}>
            <div className="w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-2xl border border-background-200/70">
              <iframe
                title={t('contactPage.mapTitle')}
                src="https://www.google.com/maps?q=Rte%20de%20Ros%C3%A9%2051%2C%201754%20Avry-sur-Matran%2C%20Suisse&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}